import axios from 'axios'
import _drop from 'lodash/drop'
import moment from 'moment'
import { getCookie } from './methods'

import { ISSUE_TYPE } from '@/util/hanatourToken'
const { api, deployEnv, hosts } = require('~/config')

export const http = axios.create({
  baseURL:
    process.env.NODE_ENV !== 'production'
      ? api.server[deployEnv]
      : process.env.API_URL || api.server[deployEnv],
  withCredentials: true,
  timeout: 30000,
})

export const cancelToken = axios.CancelToken

export const setRequestHandler = function (http, context) {
  http.interceptors.request.use(
    function (config) {
      config.headers.accessPotiosion = 'PC'

      if (context && context.isServer) {
        // 서버에서 요청할 땐 서버의 쿠키가 저절로 전송되지 않기 때문에 수동으로 쿠키를 설정해줘야 한다.
        config.cookies = context.rawCookies
        config.headers.Cookie = context.rawCookies ? context.rawCookies : ''
      }

      if (config.url.split('/')[0] === ':local') {
        config.baseURL = api.server.local
        config.url = _drop(config.url.split('/')).join('/')
      }
      const auth = context.cookie ? context.cookie.auth : getCookie('auth')
      if (auth) {
        config.headers.Authorization =
          config.sellerToken || `bearer ${JSON.parse(auth).accessToken}`
      }
      return config
    },
    function (error) {
      return Promise.reject(error)
    }
  )
}

export const setResponseHandler = function (http, context) {
  const _this = context

  http.interceptors.response.use(
    function (response) {
      console.info(
        'http.interceptors.response',
        response.status,
        response.request.responseURL || response.config.url
      )
      return response
    },
    async function (error) {
      error.response &&
        console.info(
          '[http.interceptors.response rejected ERROR]' + error.response.status,
          error.request.path || error.config.url
        )
      if (context.isServer) {
        return Promise.reject(error)
      } else {
        const response = error.response || error
        const auth = context.cookie ? context.cookie.auth : getCookie('auth')

        if (error.response) {
          let issueType = ''

          if (
            error.config.url.includes(hosts.hanatourGw) &&
            (error.response.status === 401 || error.response.status === 417)
          ) {
            const expiredTime = _this.$store.state.refreshExpiredTime
            const isValidToken = moment(expiredTime * 1000).diff(moment(), 'minutes') > 0

            if (!expiredTime || !isValidToken) {
              issueType = ISSUE_TYPE.ANONYMOUS
            } else {
              issueType = ISSUE_TYPE.REFRESH
            }

            try {
              const loginApiUrl = `${hosts.hanatourGw}/accounts/auth/login`
              const requestConfig = error.config
              await axios.post(
                loginApiUrl,
                {
                  issueType,
                },
                { withCredentials: true, timeout: 5000 }
              )
              return axios(requestConfig)
            } catch (e) {
              console.error('hanatour refresh token error===', e)
            }
          }

          if (error.response.data && error.response.data.error === 'Internal Server Error') {
            _this.$message({ message: _this.$t('common.message.tempError'), type: 'error' })

            console.error('Client Side Http Error', {
              method: error.config && error.config.method,
              status: error.response.data.status,
              reqUrl: (error.config && error.config.url) || error.response.data.path,
              message: error.response.data.message,
              token: _this.isLive || (error.config ? error.config.headers.Authorization : null),
            })
          } else if (error.response.data) {
            // _this.$message({message: error.response.data.error_description, type: 'error'});
            if (error.response.data.error === 'invalid_token') {
              const authData = JSON.parse(auth)
              if (authData.tokenExpired < Date.now()) {
                return _this.$store.dispatch('refreshAuth', authData.refreshToken)
              } else {
                // delCookie('auth')
                // return _this.$$alert('인증정보가 올바르지 않습니다. 다시 시도 바랍니다.')
              }
            }
          }
          return Promise.reject(error.response || error)
        } else {
          const resData = response.data || {}
          if (error.message !== 'cancel') {
            _this.$message({ message: _this.$t('common.message.tempError'), type: 'error' })
          }

          console.error('Client Side Http Error', {
            method: error.config && error.config.method,
            status: resData.status,
            reqUrl:
              (error.config && error.config.url) || (error.response && error.response.data.path),
            message: resData.message || error.message,
            token: _this.isLive || (error.config ? error.config.headers.Authorization : null),
          })
        }
        return Promise.reject(error)
      }
    }
  )
}
